import HeaderPaneProps from './HeaderPaneProps';
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import { FolderPicker, TodoPanel } from 'owa-todos';
import * as React from 'react';

const styles = require('./TodoPane.scss');

export default class TodoPane extends React.Component<HeaderPaneProps, {}> {
    componentDidMount() {
        lazyShowFlexPane.importAndExecute(
            <div className={styles.todosPane}>
                <TodoPanel
                    source={'SuiteHeader'}
                    closePanel={this.props.onDismiss}
                    hideFolderPicker={true}
                />
            </div>,
            {
                headerText: this.renderHeader,
                onDismiss: this.props.onDismiss,
                className: styles.todoFlex,
                overlayOnSmallWidth: false,
            }
        );
    }

    componentWillUnmount() {
        lazyHideFlexPane.importAndExecute();
    }

    render() {
        return null;
    }

    renderHeader() {
        return <FolderPicker />;
    }
}
